import { Button, Modal } from 'semantic-ui-react';
import { ImpactType } from '../../../../types';
import ImportImpact from '../importImpact';

type ImpactModalPropsType = {
    open: boolean;
    closeModal: () => void;
    impact: ImpactType;
};
function ImpactModal({ open, closeModal, impact }: ImpactModalPropsType) {
    return (
        <Modal size="small" open={open} onClose={closeModal}>
            <Modal.Content>
                <ImportImpact impact={impact} />
            </Modal.Content>
            <Modal.Actions>
                <Button secondary onClick={closeModal}>
                    CLOSE
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default ImpactModal;
